import {escapeHtml} from '../helpers';
import SvgComponent from './svg';

export default class ShareComponent {
  static CLASSES = {
    SHARE: 'share',
    SHARE_VERTICAL: 'share--vertical',
    SHARE_INVERSE: 'share--inverse',
    BUTTON: 'share__button'
  };

  static template({classList, isVertical, isInverse, socials} = {}) {
    let attrs = [
      `class="${[
        ShareComponent.CLASSES.SHARE,
        isVertical && ShareComponent.CLASSES.SHARE_VERTICAL,
        isInverse && ShareComponent.CLASSES.SHARE_INVERSE,
        classList && classList.join(' ')
      ]
        .filter((x) => x)
        .join(' ')}"`
    ]
      .filter((x) => x)
      .join(' ');

    let innerHTML = [];

    if (socials) {
      socials.forEach((social) => {
        let text = social.text && escapeHtml(social.text);

        let buttonAttrs = [
          `class="${[
            ShareComponent.CLASSES.BUTTON,
            social.type && `${ShareComponent.CLASSES.BUTTON}--${social.type}`
          ]
            .filter((x) => x)
            .join(' ')}"`,
          social.href && `href="${social.href}"`,
          text && `title="${text}"`,
          text && `aria-label="${text}"`,
          `onclick="window.open(this.href, '${text}', 'width=640,height=436,toolbar=0,status=0'); return false;"`
        ]
          .filter((x) => x)
          .join(' ');

        let buttonSvg = social.type ? SvgComponent.template({icon: social.type}) : '';
        let button = `<a ${buttonAttrs}>${buttonSvg}</a>`;

        innerHTML.push(button);
      });
    }

    innerHTML = innerHTML.filter((x) => x).join('');

    return `<div ${attrs}>${innerHTML}</div>`;
  }
}
